import createSvgIcon from '../Utils/CreateSvgIcon';

export const FileExport = createSvgIcon(
  <path d="M480-480ZM218.15-93.46 190.62-122l137.99-138H209.38v-40h186.77v186.77h-40v-118.23l-138 138ZM491.54-120v-40h203.84q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7V-640H560v-160H264.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v380h-40v-380q0-26.85 18.88-45.74Q237.77-840 264.62-840H580l180 180v475.38q0 26.85-18.88 45.74Q722.23-120 695.38-120H491.54Z" />,
  'FileExport',
  '0 -960 960 960',
);
